import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppJotaiProvider } from './JotaiProvider';
import { TanstackProvider } from './TanstackProvider';
import { ToastProvider } from './ToastProvider';

interface ProvidersProps {
  children: ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <AppJotaiProvider>
      <TanstackProvider>
        <BrowserRouter>
          {children}
          <ToastProvider />
        </BrowserRouter>
      </TanstackProvider>
    </AppJotaiProvider>
  );
};
